import { Reveal } from "@/components/shared/Reveal";

export const SectionHeading = ({
  eyebrow,
  title,
  description,
  align = "left",
  light = false,
  testId,
}) => {
  return (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      {eyebrow && (
        <Reveal>
          <div
            data-testid={testId ? `${testId}-eyebrow` : undefined}
            className={`text-xs font-bold tracking-[0.22em] uppercase mb-4 ${
              light ? "text-rr-orangeLight" : "text-rr-orange"
            }`}
          >
            {eyebrow}
          </div>
        </Reveal>
      )}
      <Reveal delay={0.08}>
        <h2
          data-testid={testId ? `${testId}-heading` : undefined}
          className={`font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.05] ${
            light ? "text-white" : "text-rr-navy"
          }`}
        >
          {title}
        </h2>
      </Reveal>
      {description && (
        <Reveal delay={0.16}>
          <p
            className={`mt-5 text-base md:text-lg leading-relaxed ${
              light ? "text-white/70" : "text-rr-muted"
            }`}
          >
            {description}
          </p>
        </Reveal>
      )}
    </div>
  );
};
